import * as React from 'react';
import { Input } from '../input/input';
import { InputProps } from 'interfaces';
import Icons from 'const/icons';
import { CypressI } from 'interfaces/cypress';

const InputPassword: React.FC<
	InputProps &
		CypressI &
		React.InputHTMLAttributes<HTMLInputElement> & {
			validate?: boolean;
		}
> = ({ rules, validate = true, ...props }) => {
	const [isVisible, setIsVisible] = React.useState(false);
	const handleClick = (): void => {
		setIsVisible(!isVisible);
	};

	const onKeyDownHandler = (event: any): void => {
		const code = event.which || event.keyCode;
		if (code === 32) event.preventDefault();
	};

	/*
		Minimum length 8 characters (no maximum). 
		One character must be uppercase.
		One character must be lowercase.
		Minimum one numeric character. 
		Include a special character (ex. *: ;-). 
		Users will not be able to choose this style of password combinations: qwerty, password, qwerty1234, 1234, among others.
  	*/
	const finalRules = React.useMemo(() => {
		if (validate) {
			return {
				...rules,
				// validate: (value: string) =>
				// 	!value.match(
				// 		new RegExp(
				// 			'qwerty|password|admin|administrator|1234|qwerty1234',
				// 			'i'
				// 		)
				// 	) ||
				// 	'Your password does not meet the minimum requirements. It must be at least 8 characters long and include one number, one uppercase letter, and one special character (_-:*).',
				pattern: {
					value: /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/,
					message:
						props.customErrorMessage ||
						'Your password does not meet the minimum requirements. It must be at least 8 characters long and include one number, one uppercase letter, and one special character (_-:*).',
				},
			};
		}
		return {
			...rules,
		};
	}, [rules, validate]);

	return (
		<Input
			type={isVisible ? 'text' : 'password'}
			rules={finalRules}
			iconRight={isVisible ? Icons.invisible : Icons.visible}
			rightClick={handleClick}
			onKeyDown={onKeyDownHandler}
			{...props}
		/>
	);
};
export default InputPassword;
